import axios from "axios";
import useLogout from "../hooks/useLogout";

const ApiClient = axios.create();

ApiClient.interceptors.request.use(
  (config) => {
    config.baseURL = process.env.REACT_APP_BACKEND_URL;
    const auth = localStorage.getItem("persist:auth");
    const user = auth ? JSON.parse(auth).user : null;
    if (user) {
      const parsedUser = JSON.parse(user);
      config.headers.Authorization = `Bearer ${parsedUser?.token}`;
    }

    return config;
  },
  (error) => {
    console.error("Request interceptor error:", error);
    return Promise.reject(error);
  }
);

export default ApiClient;
